<template>
  <div class="page-content ride-search-page">
    <div class="row">
      <div class="col-12">
        <ride-history-report />
        <active-rides />
        <ride-search-table />
        <ride-detail v-if="rideId" />
        <rides-taken-per-user />
        <rides-by-deactivated-callers />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useRide } from '@/use/ride';

import ActiveRides from './RideSearch/ActiveRides.vue';
import RideHistoryReport from './RideSearch/RideHistoryReport.vue';
import RideSearchTable from '@/components/Main/Operator/RideSearch/RideSearch.vue';
import RideDetail from '@/components/Main/Operator/RideSearch/RideDetail.vue';
import RidesTakenPerUser from '@/components/Main/Operator/RideSearch/RidesTakenPerUser.vue';
import RidesByDeactivatedCallers from './RideSearch/RidesByDeactivatedCallers.vue';

export default {
  name: 'PartnerRideHistory',

  components: {
    ActiveRides,
    RideSearchTable,
    RidesTakenPerUser,
    RideDetail,
    RideHistoryReport,
    RidesByDeactivatedCallers,
  },

  setup: () => {
    const route = useRoute();

    const { rideId } = useRide();

    onMounted(async () => {
      const hash = route.hash;

      await nextTick();
      util.moveScrollComponent(hash);
    });

    return {
      rideId,
    };
  },
};
</script>
